/**
 * Mounts the Cmd+K palette and registers the global keyboard listener
 * that opens it from anywhere in the authenticated app. Sits inside
 * AppLayout once.
 */
import { useEffect, useState } from 'react';
import { GlobalSearchPalette } from './GlobalSearchPalette';

export function GlobalSearchProvider() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setIsOpen(true);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return <GlobalSearchPalette isOpen={isOpen} onClose={() => setIsOpen(false)} />;
}
